import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTransferPricingBenchmark } from './types';

export function useTransferPricingBenchmarkByServiceRequest(
  serviceRequestId: string | null
) {
  const baseUrl = `transfer-pricing/benchmark/_?serviceRequestId=${serviceRequestId}`;

  const {
    data,
    error,
    mutate,
  }: {
    data?: TTransferPricingBenchmark | null;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    serviceRequestId ? baseUrl : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
